
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/account/activity",
      function () {
        return require("private-next-pages/docs/account/activity.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/account/activity"])
      });
    }
  